import { PropsWithChildren, FC } from 'react'
import { adminJobRequestQuery_jobRequest_parts_linesWithWorkOrderMapping as JobRequestLineType } from '@OpsQuality/JobRequestDetails/__generated__/adminJobRequestQuery'

import Box from '~/core/Box'

import styles from './styles.css'
import ThumbnailImage from './ThumbnailImage'

type ShowFirstItemPropsType = {
    firstJobRequestLine: JobRequestLineType
}

const ShowFirstItem: FC<PropsWithChildren<ShowFirstItemPropsType>> = props => {
    const { firstJobRequestLine } = props

    if (!firstJobRequestLine) {
        return null
    }

    return (
        <Box className={styles.inspectionItem}>
            <ThumbnailImage jobRequestLine={firstJobRequestLine} />
        </Box>
    )
}

export default ShowFirstItem
